import Joi, { required } from "joi";

class ValidationService {
  constructor() {
    this.user = Joi.object({
      firstName: Joi.string().min(3).required(),
      lastName: Joi.string().min(3).required(),
      email: Joi.string()
        .email({ tlds: { allow: false } })
        .required(),
      phone: Joi.string().length(10).required(),
      password: Joi.string().min(8).required(),
      confirmPassword: Joi.ref("password"),
    });

    this.fullUser = Joi.object({
      firstName: Joi.string().min(3).required(),
      lastName: Joi.string().min(3).required(),
      email: Joi.string()
        .email({ tlds: { allow: false } })
        .required(),
      phone: Joi.string().length(10).required(),
      disabled: Joi.bool().required(),
      emailVerified: Joi.bool().required(),
      phoneVerified: Joi.bool().required(),
      roleId: Joi.number().min(1).required(),
    }).unknown(true);

    this.userPass = Joi.object({
      oldPassword: Joi.string().min(8).required(),
      password: Joi.string().min(8).required(),
      confirmPassword: Joi.ref("password"),
    });

    this.emailSchema = Joi.string()
      .email({ tlds: { allow: false } })
      .required();

    this.company = Joi.object({
      vatNumber: Joi.string().length(9).regex(/^\d+$/),
      name: Joi.string().required(),
      friendlyName: Joi.string().required(),
      country: Joi.string().required(),
      city: Joi.string().required(),
      street: Joi.string().required(),
      streetNumber: Joi.string().required(),
      postalCode: Joi.string().required(),
      postalCode: Joi.string().required(),
      business: Joi.string().required(),
      gemi: Joi.string().allow("", null),
      email: Joi.string()
        .email({ tlds: { allow: false } })
        .required(),
      taxOffice: Joi.string().required(),
    }).unknown(true);

    this.unsignedInvoice = Joi.object({
      vatNumber: Joi.string().length(9).regex(/^\d+$/).allow(null),
      series: Joi.string().required(),
      aa: Joi.number().positive().required(),
      cleanAmount: Joi.number().positive().required(),
      vatAmount: Joi.number().positive().required(),
      grossAmount: Joi.number().positive().required(),
    });
  }

  isValidEmail(str) {
    const val = this.emailSchema.validate(str);
    return !val.error;
  }

  validateCompany(company) {
    const val = this.company.validate(company);
    return val.error;
  }

  validateUnsignedInvoice(invoice) {
    const val = this.unsignedInvoice.validate(invoice);
    return val.error;
  }

  validateUser(user) {
    const val = this.user.validate(user);
    return val.error;
  }

  validateFullUser(user) {
    const val = this.fullUser.validate(user);
    return val.error;
  }

  validateUserPass(pass) {
    const val = this.userPass.validate(pass);
    return val.error;
  }
}

export default new ValidationService();
